module.exports = __webpack_public_path__ + "static/media/logo.85f0ed4d.svg";